<form [formGroup]="form">
  <label>{{ 'dashboard.edit.title' | translate }}</label>
  <input type="text" formControlName="title" class="form-control" />

  <label>{{ 'dashboard.edit.description' | translate }}</label>
  <input type="text" formControlName="description" class="form-control" />

  @if (!isTemplateDashboard) {
    <label>{{
      'dashboard.edit.AveragePickTimeDashboardComponent.dataConnections'
        | translate
    }}</label>
    <p-multiselect
      [options]="dataConnections"
      formControlName="dataConnectionIds"
      optionValue="id"
      [filter]="true"
      [showClear]="true"
      [showToggleAll]="false"
      optionLabel="name"
      class="w-100"
    />
  }

  <label>{{
    'dashboard.edit.AveragePickTimeDashboardComponent.statuses' | translate
  }}</label>
  <p-multiselect
    [options]="statusOptions"
    formControlName="statuses"
    optionValue="value"
    [filter]="false"
    [showClear]="true"
    [showToggleAll]="false"
    optionLabel="key"
    class="w-100"
  >
    <ng-template let-selectedOption pTemplate="selectedItem">
      {{ 'job.statusOptions.' + selectedOption.key | translate }}
    </ng-template>
    <ng-template let-option pTemplate="item">
      {{ 'job.statusOptions.' + option.key | translate }}
    </ng-template>
  </p-multiselect>
  <small class="text-muted d-block mb-2">
    {{
      'dashboard.edit.AveragePickTimeDashboardComponent.statusesHint'
        | translate
    }}
  </small>

  <label>{{
    'dashboard.edit.AveragePickTimeDashboardComponent.range' | translate
  }}</label>
  <p-select
    formControlName="range"
    [options]="rangeOptions"
    optionLabel="key"
    optionValue="value"
    class="w-100"
  >
    <ng-template let-selectedOption pTemplate="selectedItem">
      {{
        'dashboard.edit.JobDashboardComponent.rangeOptions.' +
          selectedOption.key | translate
      }}
    </ng-template>
    <ng-template let-option pTemplate="item">
      {{
        'dashboard.edit.JobDashboardComponent.rangeOptions.' + option.key
          | translate
      }}
    </ng-template>
  </p-select>

  @if (form.get('range')!.value === customRange) {
    <label>{{
      'dashboard.edit.JobDashboardComponent.rangeOptions.CUSTOM' | translate
    }}</label>
    <p-datepicker
      required
      [(ngModel)]="dateRange"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="customRangeChange($event)"
      selectionMode="range"
      dateFormat="dd.mm.yy"
      [showIcon]="true"
      [showButtonBar]="true"
      [numberOfMonths]="1"
      styleClass="w-100"
      inputStyleClass="w-100"
      [class.is-invalid]="dateRangeError"
    />
    @if (dateRangeError) {
      <div class="invalid-feedback d-block">{{ dateRangeError }}</div>
    }
    <small class="text-muted d-block mb-2">
      {{
        'dashboard.edit.AveragePickTimeDashboardComponent.maxDateRange'
          | translate: { days: maxDateRangeDays }
      }}
    </small>
  }

  <hr class="my-3" />

  <div class="d-flex justify-content-between align-items-center mb-2">
    <label class="mb-0">
      {{
        'dashboard.edit.AveragePickTimeDashboardComponent.unitSource'
          | translate
      }}
    </label>
    @if (!isTemplateDashboard) {
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        (click)="discoverFields()"
        [disabled]="isLoadingFields"
      >
        @if (isLoadingFields) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        {{
          'dashboard.edit.AveragePickTimeDashboardComponent.discoverFields'
            | translate
        }}
      </button>
    }
  </div>

  <p-select
    formControlName="unitSourceType"
    [options]="unitSourceTypeOptions"
    optionLabel="key"
    optionValue="value"
    class="w-100"
  >
    <ng-template let-selectedOption pTemplate="selectedItem">
      {{
        'dashboard.edit.AveragePickTimeDashboardComponent.unitSourceOptions.' +
          selectedOption.key | translate
      }}
    </ng-template>
    <ng-template let-option pTemplate="item">
      {{
        'dashboard.edit.AveragePickTimeDashboardComponent.unitSourceOptions.' +
          option.key | translate
      }}
    </ng-template>
  </p-select>
  <small class="text-muted d-block mb-2">
    {{
      'dashboard.edit.AveragePickTimeDashboardComponent.unitSourceHint'
        | translate
    }}
  </small>

  @if (isFieldSum()) {
    <label>{{
      'dashboard.edit.AveragePickTimeDashboardComponent.unitField' | translate
    }}</label>
    @if (availableFields.length === 0 && !isLoadingFields) {
      <div class="alert alert-info py-2">
        {{
          'dashboard.edit.AveragePickTimeDashboardComponent.noFieldsFound'
            | translate
        }}
      </div>
    }
    <p-select
      formControlName="unitFieldKey"
      [options]="getNumericFieldOptions()"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      [showClear]="true"
      placeholder="Select field"
      class="w-100"
    />
    <small class="text-muted d-block mb-2">
      {{
        'dashboard.edit.AveragePickTimeDashboardComponent.unitFieldHint'
          | translate
      }}
    </small>
  }

  <hr class="my-3" />

  <div class="d-flex justify-content-between align-items-center mb-2">
    <label class="mb-0">
      {{
        'dashboard.edit.AveragePickTimeDashboardComponent.filters' | translate
      }}
      <span class="text-muted small ms-1"
        >({{ filters.length }}/{{ maxFilters }})</span
      >
    </label>
    <button
      type="button"
      class="btn btn-sm btn-outline-primary"
      (click)="addFilter()"
      [disabled]="filters.length >= maxFilters"
    >
      {{
        'dashboard.edit.AveragePickTimeDashboardComponent.addFilter' | translate
      }}
    </button>
  </div>
  @if (filters.length >= maxFilters) {
    <div class="alert alert-info py-1 mb-2">
      {{
        'dashboard.edit.AveragePickTimeDashboardComponent.maxFiltersReached'
          | translate: { max: maxFilters }
      }}
    </div>
  }

  <div formArrayName="filters">
    @for (filter of filters.controls; track filter; let i = $index) {
      <div class="card mb-2">
        <div class="card-body py-2">
          <div [formGroupName]="i" class="row align-items-end">
            <div class="col-4">
              <label class="small">{{
                'dashboard.edit.AveragePickTimeDashboardComponent.fieldKey'
                  | translate
              }}</label>
              <p-select
                formControlName="fieldKey"
                [options]="getFieldOptions()"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                [showClear]="true"
                placeholder="Select field"
                class="w-100"
              />
            </div>
            <div class="col-3">
              <label class="small">{{
                'dashboard.edit.AveragePickTimeDashboardComponent.operator'
                  | translate
              }}</label>
              <p-select
                formControlName="operator"
                [options]="filterOperators"
                optionLabel="key"
                optionValue="value"
                class="w-100"
              >
                <ng-template let-selectedOption pTemplate="selectedItem">
                  {{
                    'dashboard.edit.JobResultAnalyticsDashboardComponent.filterOperators.' +
                      selectedOption.key | translate
                  }}
                </ng-template>
                <ng-template let-option pTemplate="item">
                  {{
                    'dashboard.edit.JobResultAnalyticsDashboardComponent.filterOperators.' +
                      option.key | translate
                  }}
                </ng-template>
              </p-select>
            </div>
            <div class="col-3">
              <label class="small">{{
                'dashboard.edit.AveragePickTimeDashboardComponent.value'
                  | translate
              }}</label>
              <input
                type="text"
                formControlName="value"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-2">
              <button
                type="button"
                class="btn btn-sm btn-outline-danger w-100"
                (click)="removeFilter(i)"
              >
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</form>
